/** @jsx jsx */
import { jsx, css } from "@emotion/core";

interface LogoSymbolProps {
  width?: string;
  className?: string;
}

const LogoSymbol: React.SFC<LogoSymbolProps> = ({ width = "256px" }) => (
  <div
    css={css`
      width: ${width};
      height: auto;
    `}
  >
    <img
      css={css`
        width: 100%;
      `}
      alt="Lawfully"
      src={process.env.PUBLIC_URL + "/android-icon-256x256.png"}
    />
  </div>
);

export default LogoSymbol;
